import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { companyInfo, footerLinks, footerNavigation } from '@/data/mock';

export const Footer = () => {
  return (
    <footer className="bg-ybro-primary text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="/logo.svg" 
                alt="yBro" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/80 font-body max-w-md mb-6 leading-relaxed">
              Expert GBP Management, Review Handling, Local SEO, Ad Campaigns & DMCC Act Compliance for UK businesses.
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href={`mailto:${companyInfo.email}`}
                className="inline-flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-300"
              >
                <Mail className="w-5 h-5" />
                {companyInfo.email}
              </a>
              <a 
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="inline-flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-300"
              >
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="text-sm font-heading font-semibold uppercase tracking-wider text-white/90 mb-6">Navigation</h3>
            <ul className="space-y-3">
              {footerNavigation.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href}
                    className="text-white/80 hover:text-white transition-colors duration-300 font-body"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-sm font-heading font-semibold uppercase tracking-wider text-white/90 mb-6">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href}
                    className="text-white/80 hover:text-white transition-colors duration-300 font-body"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/20">
          <p className="text-white/70 text-sm text-center font-body">
            {companyInfo.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};
